module.exports = __webpack_public_path__ + "static/img/przybornik_pedzel.fb29cab4.png";